import { render, staticRenderFns } from "./search-output.vue?vue&type=template&id=118ef3b4&"
import script from "./search-output.vue?vue&type=script&lang=js&"
export * from "./search-output.vue?vue&type=script&lang=js&"
import style0 from "./search-output.vue?vue&type=style&index=0&id=118ef3b4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports